<template>
<div>

  <!-- Owner Menu -->
   <div v-if="!$page.props.auth.user.owner">
      <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('properties')">
        <icon name="home" class="w-4 h-4 mr-2" :class="isUrl('inmuebles') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" />
        <div :class="isUrl('inmuebles') ? 'text-white' : 'text-blue-100 group-hover:text-white'">Inmuebles</div>
      </inertia-link>
    </div> 
      <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('logout')" method="delete" as="button">
        <!-- <icon name="mail" class="w-4 h-4 mr-2" :class="isUrl('reports') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" /> -->
        <div class="text-blue-100 group-hover:text-white">Salir del Sistema</div>
      </inertia-link>
    </div>
   </div>
   <!-- Admin Menu -->
  <div v-if="$page.props.auth.user.owner">
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('dashboard')">
        <icon name="dashboard" class="w-4 h-4 mr-2" :class="isUrl('') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" />
        <div :class="isUrl('') ? 'text-white' : 'text-blue-100 group-hover:text-white'">Panel</div>
      </inertia-link>
    </div>
     
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('advertisers')">
        <icon name="users" class="w-4 h-4 mr-2" :class="isUrl('anunciantes') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" />
        <div :class="isUrl('anunciantes') ? 'text-white' : 'text-blue-100 group-hover:text-white'">Anunciantes</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('properties')">
        <icon name="home" class="w-4 h-4 mr-2" :class="isUrl('inmuebles') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" />
        <div :class="isUrl('inmuebles') ? 'text-white' : 'text-blue-100 group-hover:text-white'">Inmuebles</div>
      </inertia-link>
    </div> 
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('ads')">
        <icon name="store-front" class="w-4 h-4 mr-2" :class="isUrl('publicidad') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" />
        <div :class="isUrl('publicidad') ? 'text-white' : 'text-blue-100 group-hover:text-white'">Experiencias</div>
      </inertia-link>
    </div>
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('locations')">
        <icon name="location" class="w-4 h-4 mr-2" :class="isUrl('localidades') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" />
        <div :class="isUrl('localidades') ? 'text-white' : 'text-blue-100 group-hover:text-white'">Localidades</div>
      </inertia-link>
    </div> 
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('category')">
        <icon name="office" class="w-4 h-4 mr-2" :class="isUrl('categorias') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" />
        <div :class="isUrl('categorias') ? 'text-white' : 'text-blue-100 group-hover:text-white'">Categorias</div>
      </inertia-link>
    </div> 
    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('mailing')">
        <icon name="mail" class="w-4 h-4 mr-2" :class="isUrl('mailing') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" />
        <div :class="isUrl('mailing') ? 'text-white' : 'text-blue-100 group-hover:text-white'">Mailing</div>
      </inertia-link>
    </div>

    <div class="mb-4">
      <inertia-link class="flex items-center group py-3" :href="route('logout')" method="delete" as="button">
        <!-- <icon name="mail" class="w-4 h-4 mr-2" :class="isUrl('reports') ? 'fill-white' : 'fill-indigo-500 group-hover:fill-white'" /> -->
        <div class="text-blue-100 group-hover:text-white">Salir del Sistema</div>
      </inertia-link>
    </div>

</div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  methods: {
    isUrl(...urls) {
      let currentUrl = this.$page.url.substr(1)
      if (urls[0] === '') {
        return currentUrl === ''
      }
      return urls.filter(url => currentUrl.startsWith(url)).length
    },
  },
}
</script>
